import styled from 'styled-components';

export const DividerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: #eeeeee;
`;

export const DividerLabel = styled.span`
  font-size: 10px;
  color: #a3a5a9;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  white-space: nowrap;
`;
